import React from 'react';
import { Image, UserCheck, X } from 'lucide-react';
import styles from './IdentityTable.module.scss';
import StatusBadge from '../Shared/StatusBadge.tsx';

interface IdentityTableProps {
  users: any[];
  onViewImages: (user: any) => void;
  onValidate: (userId: string, isValid: boolean) => void;
}

const IdentityTable: React.FC<IdentityTableProps> = ({
  users,
  onViewImages,
  onValidate
}) => {
  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Estado</th>
            <th>Imágenes</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => {
            const userId = user.id ?? user.jobBoard?.id;
            const userName = user.name ?? user.jobBoard?.name;
            const userEmail = user.email ?? user.jobBoard?.email;
            const identityValidated = user.identity_validated ?? user.jobBoard?.identity_validated;
            return (
            <tr key={index}>
              <td>{userId}</td>
              <td>{userName}</td>
              <td>{userEmail}</td>
              <td>
                <StatusBadge 
                  status={identityValidated} 
                  type="identity"
                />
              </td>
               <td>
                <button
                  className={styles.viewButton}
                  onClick={() => onViewImages(user)}
                >
                  <Image size={16} />
                  Ver
                </button>
              </td>
              <td>
                {identityValidated === null ? (
                  <div className={styles.actionButtons}>
                    <button
                      className={styles.approveButton}
                      onClick={() => userId && onValidate(String(userId), true)}
                    >
                      <UserCheck size={16} />
                      Aceptar
                    </button>
                    <button
                      className={styles.rejectButton}
                      onClick={() => userId && onValidate(String(userId), false)}
                    >
                      <X size={16} />
                      Rechazar
                    </button>
                  </div>
                ) : (
                  <button className={styles.approveButton} disabled>
                    <UserCheck size={16} />
                    Validado
                  </button>
                )}
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default IdentityTable;

